import { BaseComponent, cssHelper } from "react-vextensions";
import { Vector2 } from "js-vextensions";
import React from "react";
export class DraggableLabel extends BaseComponent {
    constructor() {
        super(...arguments);
        this.OnMouseMove_Global = (e) => {
            const { onDrag } = this.props;
            const mousePos = new Vector2(e.pageX, e.pageY);
            onDrag(mousePos.Minus(this.lastMousePos), mousePos.Minus(this.mouseDownPos), false);
            this.lastMousePos = mousePos;
        };
        this.OnMouseUp_Global = (e) => {
            const { onDrag } = this.props;
            const mousePos = new Vector2(e.pageX, e.pageY);
            onDrag(mousePos.Minus(this.lastMousePos), mousePos.Minus(this.mouseDownPos), true);
            this.RemoveListeners();
        };
    }
    render() {
        const { onDragStart, onDrag, style, ...rest } = this.props;
        const { css } = cssHelper(this);
        return (React.createElement("label", { ...rest, style: css(onDrag && { cursor: "col-resize" }, style), onMouseDown: e => {
                if (onDrag == null)
                    return;
                this.mouseDownPos = new Vector2(e.pageX, e.pageY);
                this.lastMousePos = this.mouseDownPos;
                onDragStart();
                document.addEventListener("mousemove", this.OnMouseMove_Global);
                document.addEventListener("mouseup", this.OnMouseUp_Global);
            } }));
    }
    ComponentWillUnmount() {
        this.RemoveListeners();
    }
    RemoveListeners() {
        document.removeEventListener("mousemove", this.OnMouseMove_Global);
        document.removeEventListener("mouseup", this.OnMouseUp_Global);
    }
}
//# sourceMappingURL=DraggableLabel.js.map